module.exports = __webpack_public_path__ + "img/2give.9f370dcf.svg";